import React from 'react';
import * as S from './ElitePackageCard.styles';
import {useSelector} from 'react-redux';
import {packagesSelector} from '@stencil/hotels-cg-reducer/src/details/selectors';
import {appConfig} from '@stencil/hotels-config';
import Modal, {useModal} from '@stencil/hotels-modal-component';
import ElitPackageContainerUI from './ElitePackageContainerUI';

interface ElitePackageDetailsCardProps {
  customStyles?: React.CSSProperties;
  handlOpenCalendar?: () => void;
}

const FCZPN = 'FCZPN';

export default function ElitePackageDetailsCard({
  customStyles = {},
  handlOpenCalendar = () => {},
}: ElitePackageDetailsCardProps) {
  const {rupeeString} = appConfig;
  const {isModalOpen, openModal, closeModal} = useModal();
  const elitePackageData = useSelector(packagesSelector);

  const getRatePlanInfo = ({ratePlan = {}}) => {
    const bookAtInfo = ratePlan?.inclusionsList.find(item => item.type === FCZPN);
    const inclusionsToShow = ratePlan?.inclusionsList.filter(item => item.type !== FCZPN);
    return {bookAtInfo, inclusionsToShow};
  };

  const onMoreInfoClick = ({roomData}) => {
    openModal();
  };

  if (!elitePackageData?.length) return null;

  return (
    <>
      {elitePackageData.map((item, idx) => {
        const {
          roomHighlights = [],
          packageBenefits = '',
          ratePlans = [],
          images,
          roomCode,
          roomName,
        } = item;
        return (
          <S.MainWrapper style={{...customStyles}}>
            <S.InnerWrapper>
              <S.TopWrapper>
                <S.ElitePackageTagWrapper>
                  <S.ElitePackageTag>ELITE PACKAGE</S.ElitePackageTag>
                </S.ElitePackageTagWrapper>
                <S.ElitePackageDesc>{packageBenefits}</S.ElitePackageDesc>
              </S.TopWrapper>
              <ElitPackageContainerUI data={item} handlOpenCalendar={handlOpenCalendar} />
            </S.InnerWrapper>
          </S.MainWrapper>
        );
      })}
    </>
  );
}
